import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import { checkLogin } from './auth/utils'
import { installAppState } from './utils/app-state'
import * as Sentry from "@sentry/vue";

(async () => {

  Vue.use(ToastPlugin)
  Vue.use(ModalPlugin)

  
  Sentry.init({
    Vue,
    dsn: "https://b6f2756b7ae05c5fa7fe1ac6eab3837f@o4511313608179712.ingest.de.sentry.io/4512145933402192",
    integrations: [
      Sentry.browserTracingIntegration({ router })
    ],
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of the traces
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/api\.sens-eye\.fr\/api/]
  });
  // Composition API
  Vue.use(VueCompositionAPI)

  // import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

  Vue.prototype.$user = await checkLogin()
  installAppState(Vue)
  Vue.prototype.$isAdmin = Vue.prototype.$user ? Vue.prototype.$user.roles.includes('ROLE_ADMIN') : false
  Vue.prototype.$isFactory = Vue.prototype.$user ? Vue.prototype.$user.roles.includes('ROLE_FACTORY') : false
  Vue.config.productionTip = false

  const publicRouteNames = ['login', 'scanReview', 'scanFitting', 'scanFittingGlass', 'addPrescription', 'orderDetailApp']

  router.beforeEach((to, from, next) => {
    if (!Vue.prototype.$user && !publicRouteNames.includes(to.name)) {
      next({ name: 'login' })
      return
    }
    next()
  })

  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')

})();

// BSV Plugin Registration
